import React from 'react';
import { Container } from '@mui/material';
import BIPTemplateGenerator from '../components/BIPTemplateGenerator';

const BIPTemplateGeneratorPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <BIPTemplateGenerator />
    </Container>
  );
};

export default BIPTemplateGeneratorPage;